module.exports = __webpack_public_path__ + "static/media/closed-grey.4980acda.svg";